export default "__VITE_ASSET__DYyaCDyX__"